/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */

/**
 * Do PUT: /view/items/<uuid> call everytime the category is changed on the menu screen.
 * Call is also made after the first render of menu screen.
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config, { HTTP_STATUS } from "../../../config/config";

const putItemListInitialState = {
  loading: null,
  data: [],
};

export const putItemList = createAsyncThunk(
  "tokkio/putItemList",
  async (putPayload, { getState }) => {
    const state = getState();
    if(state.uuid.sessionActive) {
      const { data } = axios(
        `${config.uiServerEndpoint}/view/items/${state.uuid.sessionId}`,
        {
          method: "put",
          data: putPayload,
        }
      );
      // console.info(
      //   "Successful PUT request for items",
      //   putPayload.items,
      //   " and view",
      //   putPayload.view
      // );
      // console.debug("put response: ", data);
      return data;
    }
    return null;
  }
);

const putItemListSlice = createSlice({
  name: "putItemList",
  initialState: putItemListInitialState,
  reducers: {},
  extraReducers: {
    [putItemList.pending](state) {
      state.loading = HTTP_STATUS.PENDING;
    },
    [putItemList.fulfilled](state, { payload }) {
      state.loading = HTTP_STATUS.FULFILLED;
      state.data = payload;
    },
    [putItemList.rejected](state) {
      state.loading = HTTP_STATUS.REJECTED;
    },
  },
});

export const putItemListActions = putItemListSlice.actions;
export default putItemListSlice;
